import { render, staticRenderFns } from "./ConfirmSubmitApproveProvider.vue?vue&type=template&id=8ec20154&scoped=true&"
import script from "./ConfirmSubmitApproveProvider.vue?vue&type=script&lang=ts&"
export * from "./ConfirmSubmitApproveProvider.vue?vue&type=script&lang=ts&"
import style0 from "./ConfirmSubmitApproveProvider.vue?vue&type=style&index=0&id=8ec20154&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ec20154",
  null
  
)

export default component.exports